var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 21.9323C10.537 21.9323 9.34824 20.7436 9.34824 19.2812H11.2351C11.2351 19.7058 11.5842 20.0454 11.9993 20.0454C12.4144 20.0454 12.7635 19.6964 12.7635 19.2812H14.6503C14.6598 20.7341 13.4711 21.9323 11.9993 21.9323Z",
    fill: "#7175AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66824 15.3464C5.20591 15.3464 4.01718 14.1576 4.01718 12.6953H5.90405C5.90405 13.1199 6.25313 13.4595 6.66824 13.4595C7.08335 13.4595 7.43242 13.1104 7.43242 12.6953H9.3193C9.32873 14.1576 8.13057 15.3464 6.66824 15.3464Z",
    fill: "#FFA726"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3491 19.2543C15.8868 19.2543 14.6981 18.0655 14.6981 16.6032V4.66865C14.6981 3.20632 15.8868 2.01758 17.3491 2.01758C18.8114 2.01758 20.0002 3.20632 20.0002 4.66865V16.5938C20.0096 18.0655 18.8114 19.2543 17.3491 19.2543ZM17.3491 3.90446C16.9246 3.90446 16.5849 4.25354 16.5849 4.66865V16.5938C16.5849 17.0183 16.934 17.3579 17.3491 17.3579C17.7642 17.3579 18.1133 17.0089 18.1133 16.5938V4.66865C18.1227 4.25354 17.7737 3.90446 17.3491 3.90446Z",
    fill: "#FFA726"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.2556C10.5377 19.2556 9.34894 18.0668 9.34894 16.6045V2H11.2358V16.6045C11.2358 17.029 11.5849 17.3687 12 17.3687C12.4151 17.3687 12.7642 17.0196 12.7642 16.6045V2H14.6511V16.6045C14.6605 18.0668 13.4718 19.2556 12 19.2556Z",
    fill: "#7175AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31155 18.3108H7.42467V4.66865C7.42467 4.2441 7.0756 3.90446 6.66049 3.90446C6.24538 3.90446 5.88687 4.25354 5.88687 4.66865V18.3108H4V4.66865C4 3.20632 5.18873 2.01758 6.65106 2.01758C8.11338 2.01758 9.30211 3.20632 9.30211 4.66865V18.3108H9.31155Z",
    fill: "#FFA726"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.2b6f6c456299859c41a8aa061ad36263.svg";
export { ForwardRef as ReactComponent };